import styled from "styled-components";

export const LoadTimingStyled = styled.div`
  margin-top: 13px;

  .btn--colored {
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;

    position: relative;
    cursor: pointer;

    width: 177px;
    color: white;
    border-radius: 8px;
  }

  .btn--colored__icon {
    position: absolute;
    right: 6px;
    top: 0;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .btn--colored-blue {
    background-color: #3278d7;
    box-shadow: 0 4px 10px 0 rgba(50, 120, 215, 0.2);
  }

  .btn--colored-green {
    background-color: #48cfad;
  }

  .text-area {
    width: 100%;
    max-height: 48px;
    padding: 4px 6px;
    border-radius: 8px;
    border: none;
    margin-top: 14px;
  }

  .input {
  }
`;
